<template>
  <div class="traveller filter-form">
    <multiselect v-model="selected"
                 v-bind="selectProps"
                 :placeholder="$t('booking.array.select_traveller')"
                 @input="emitChanges"
    >
      <template slot="noOptions">
        {{ $t('_empty_list') }}
      </template>
    </multiselect>

    <p class="text-right">
      <b-button class="btn-as-link" @click="reset">
        {{ $t('_reset') }}
      </b-button>
    </p>
  </div>
</template>

<script>
import filtersMixin from "./mixin";

export default {
  mixins: [filtersMixin],

  data () {
    return {
      multipleSelect: true,
      selected: []
    }
  },

  methods: {
    reset () {
      this.selected = []
      this.emitChanges()
    }
  }
}
</script>
